import { api } from 'hooks/useApi';

const BASE_URL = 'https://service-polygon-cft2uqyhma-uc.a.run.app';

type TFetchPolygons = {
  max_lat: number;
  max_long: number;
  min_lat: number;
  min_long: number;
};

const fetchPolygonsByLatLong = ({
  max_lat,
  max_long,
  min_lat,
  min_long,
}: TFetchPolygons) => {
  return api.post(`${BASE_URL}/polygon`, {
    max_lat,
    max_long,
    min_lat,
    min_long,
  });
};

export default {
  fetchPolygonsByLatLong,
};
